var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "syf-component-library/ui/patterns/Grid";
import useFeaturedContentData from "../../../hooks/useFeaturedContentData";
import DescriptionList from "../../atoms/DescriptionList";
import { FeaturedContentWithMeter } from "../FeaturedContentWithMeter/FeaturedContentWithMeter";
import PrimaryFeaturedContent from "../PrimaryFeaturedContent";
import SecondaryFeaturedContent from "../SecondaryFeaturedContent";
import { VerticalLine } from "./subcomponents";
var FeaturedContent = function () {
    var hasMeter = useFeaturedContentData().hasMeter;
    if (hasMeter) {
        return _jsx(FeaturedContentWithMeter, {});
    }
    return (_jsx(DescriptionList, { children: _jsxs(Grid, __assign({ container: true, direction: "row" }, { children: [_jsx(PrimaryFeaturedContent, {}), _jsx(VerticalLine, { "data-testid": "verticalLine" }), _jsx(SecondaryFeaturedContent, {})] })) }));
};
export default FeaturedContent;
//# sourceMappingURL=FeaturedContent.js.map